import { useMemo } from 'react'
import ReactApexChart from 'react-apexcharts'
import { ApexOptions } from 'apexcharts'
import Swal from 'sweetalert2'
import { MODEL_STATUS, RETRAIN_HISTORY } from './mockData'
import { FEATURE_IMPORTANCE } from './edaMockData'

const AiModelStatusView = () => {
  const compareOptions: ApexOptions = useMemo(
    () => ({
      chart: { type: 'bar', toolbar: { show: false } },
      plotOptions: { bar: { columnWidth: '45%', borderRadius: 4 } },
      dataLabels: { enabled: true, formatter: (v) => `${v}%` },
      xaxis: { categories: ['h=1', 'h=7', 'h=30'] },
      yaxis: { title: { text: 'Site WAPE %' }, max: 35 },
      colors: ['#A1A5B7', '#3E97FF'],
      legend: { position: 'top' },
    }),
    []
  )

  const compareSeries = useMemo(
    () => [
      {
        name: 'Seasonal naive',
        data: [MODEL_STATUS.naiveWape.h1, MODEL_STATUS.naiveWape.h7, MODEL_STATUS.naiveWape.h30],
      },
      {
        name: 'AI v2 (champion)',
        data: [MODEL_STATUS.wape.h1, MODEL_STATUS.wape.h7, MODEL_STATUS.wape.h30],
      },
    ],
    []
  )

  return (
    <>
      <div className='row g-5 mb-5'>
        <div className='col-lg-8'>
          <div className='card h-100'>
            <div className='card-header border-0 pt-5'>
              <h3 className='card-title fw-bold'>Champion model</h3>
              <div className='card-toolbar'>
                <span className='badge badge-light-success me-2'>Healthy</span>
                <span className='badge badge-light'>{MODEL_STATUS.version}</span>
              </div>
            </div>
            <div className='card-body'>
              <div className='row g-5'>
                <div className='col-md-4'>
                  <div className='fs-7 text-muted'>Champion since</div>
                  <div className='fw-bold fs-5'>{MODEL_STATUS.championSince}</div>
                </div>
                <div className='col-md-4'>
                  <div className='fs-7 text-muted'>Last retrain</div>
                  <div className='fw-bold fs-5'>{MODEL_STATUS.lastRetrain}</div>
                </div>
                <div className='col-md-4'>
                  <div className='fs-7 text-muted'>Next scheduled</div>
                  <div className='fw-bold fs-5'>{MODEL_STATUS.nextScheduledRetrain}</div>
                </div>
                <div className='col-md-4'>
                  <div className='fs-7 text-muted'>Training rows</div>
                  <div className='fw-bold fs-5'>{MODEL_STATUS.rowsTrained.toLocaleString()}</div>
                </div>
                <div className='col-md-4'>
                  <div className='fs-7 text-muted'>Meters in model</div>
                  <div className='fw-bold fs-5'>{MODEL_STATUS.meters}</div>
                </div>
                <div className='col-md-4'>
                  <div className='fs-7 text-muted'>Forecast origin</div>
                  <div className='fw-bold fs-5'>{MODEL_STATUS.originDate}</div>
                </div>
              </div>

              <div className='separator my-6' />

              <div className='mb-3 fw-semibold'>Top features</div>
              <div className='d-flex flex-wrap gap-2 mb-6'>
                {FEATURE_IMPORTANCE.slice(0, 8).map((f) => (
                  <span key={f.feature} className='badge badge-light-primary'>
                    {f.feature} · {f.gainPct}%
                  </span>
                ))}
              </div>

              <button
                type='button'
                className='btn btn-warning'
                onClick={() =>
                  Swal.fire({
                    icon: 'success',
                    title: 'Retrain queued',
                    timer: 1400,
                    showConfirmButton: false,
                  })
                }
              >
                Queue retrain
              </button>
            </div>
          </div>
        </div>
        <div className='col-lg-4'>
          <div className='card h-100'>
            <div className='card-header border-0 pt-5'>
              <h3 className='card-title fw-bold'>Naive vs AI v2</h3>
            </div>
            <div className='card-body'>
              <ReactApexChart
                options={compareOptions}
                series={compareSeries}
                type='bar'
                height={280}
              />
            </div>
          </div>
        </div>
      </div>

      <div className='card border-0 shadow-sm'>
        <div className='card-header border-0 pt-6'>
          <h3 className='card-title fw-bold fs-4'>Retrain history</h3>
        </div>
        <div className='card-body py-3'>
          <div className='table-responsive'>
            <table className='table table-row-dashed align-middle gs-0 gy-3'>
              <thead>
                <tr className='fw-semibold text-muted'>
                  <th>Date</th>
                  <th>WAPE h=7</th>
                  <th>Decision</th>
                  <th>Note</th>
                </tr>
              </thead>
              <tbody>
                {RETRAIN_HISTORY.map((r) => (
                  <tr key={r.date}>
                    <td>{r.date}</td>
                    <td>{r.wapeH7}%</td>
                    <td>
                      <span
                        className={`badge ${
                          r.status === 'promoted' ? 'badge-light-success' : 'badge-light-danger'
                        }`}
                      >
                        {r.status}
                      </span>
                    </td>
                    <td className='text-muted'>{r.note || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  )
}

export default AiModelStatusView
